/** Canvas connector stems/lines use the same CSS variable as handle borders. */
export const CANVAS_CONNECTOR_COLOR = "var(--sp-handle-border)";

/** Default edge stroke stored on persisted React Flow edges from older builds. */
export const CANVAS_EDGE_STORED_STROKE = "#C9D5E1";
